import { symbol_custom_ai_assistant } from 'components/custom-symbols/symbols/custom_ai_assistant';
import { symbol_custom_more_horiz } from 'components/custom-symbols/symbols/custom_more_horiz';
import { symbol_custom_thumb_down_filled } from 'components/custom-symbols/symbols/custom_thumb_down_filled';
import { symbol_custom_thumb_up_filled } from 'components/custom-symbols/symbols/custom_thumb_up_filled';

// Hand-maintained registry of custom (non-Material) symbols. Keys are prefixed
// with `custom_` so they're unmistakably custom. To add one: create a
// `custom_*.tsx` file mirroring the shape above, import it, and add an entry.
export const CustomSymbols = Object.freeze({
	custom_ai_assistant: symbol_custom_ai_assistant,
	custom_more_horiz: symbol_custom_more_horiz,
	custom_thumb_down_filled: symbol_custom_thumb_down_filled,
	custom_thumb_up_filled: symbol_custom_thumb_up_filled,
});

export type CustomSymbolVariant = keyof typeof CustomSymbols;
